export default "__VITE_ASSET__RoDj17sC__"